export const restricted = {
    title: "Accès refusé !",
    text1: "Comme dans les films où les gens hackent la CIA avec un cure dent 😊.",
    text2: "Sinon, ça veut dire que vous n'avez pas accès à cette page avec votre profil."
}